import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import type { FC } from 'react';
import { MetricColumnContainer, MetricLabel, MetricValue } from './AltDealStructurePrimaryCard.style';

interface MetricColProps {
    label: string;
    value: string;
}

export const MetricCol: FC<MetricColProps> = ({ label, value }) => {
    const theme = useInterstateTheme();

    return (
        <MetricColumnContainer data-testid={`alt-deal-primary-metric-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            <MetricLabel theme={theme} variant="body-md">
                {label}
            </MetricLabel>
            <MetricValue theme={theme} variant="body-md">
                {value}
            </MetricValue>
        </MetricColumnContainer>
    );
};
